import React from 'react';
import styled from 'styled-components';
import { Card } from 'common/components/Card';

type DashboardCardProps = {
  title?: string;
  titleMargin?: string;
  controls?: React.ReactNode;
  onClick?: () => void;
  children: React.ReactNode;
  height?: string;
  showDivider?: boolean;
  borderless?: boolean;
  shadowless?: boolean;
  padding?: string;
};

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  titleMargin = '15px',
  controls,
  onClick,
  children,
  height,
  showDivider = false,
  borderless = false,
  shadowless = false,
  padding,
}) => (
  <Card onClick={onClick} height={height} borderless={borderless} shadowless={shadowless} padding={padding}>
    <HeaderContainer>
      {title ? <CardTitle titleMargin={titleMargin}>{title}</CardTitle> : null}
      {controls && <ControlContainer>{controls}</ControlContainer>}
    </HeaderContainer>
    {showDivider && <HeaderDivider />}
    <ContentContainer>{children}</ContentContainer>
  </Card>
);
export default DashboardCard;

const CardTitle = styled.div<{ titleMargin?: string }>`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: ${({ titleMargin }) => (titleMargin ? titleMargin : '15px')};
  text-align: left;
`;

const ContentContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  flex: 1;
  min-height: 0;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const HeaderDivider = styled.div`
  height: 1px;
  background-color: #e5e7eb;
  margin: 8px -20px 12px -20px; /* extend to card edges (card has 20px padding) */
  width: calc(100% + 40px);
`;

interface ControlContainerProps {
  gap?: boolean;
  justify?: 'left' | 'right' | 'center';
}

export const ControlContainer = styled.div<ControlContainerProps>`
  display: flex;
  width: 50%;
  flex-direction: row;
  align-items: center;
  gap: ${({ gap = true }) => (gap ? '8px' : '0')};
  justify-content: ${({ justify }) => {
    switch (justify) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      case 'center':
        return 'center';
      default:
        return 'flex-end';
    }
  }};
`;
